import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../components/export'
import { useAuth } from '../../context/AuthContext'
import StatusMessage from '../../components/StatusMessage'
import { patchUpdatePassword } from '../../repositories/userRepository'

const ResetPassword = () => {
  const { user } = useAuth()
  const userId = user.id
  const navigate = useNavigate()
  const [confirm, setConfirm] = useState('')
  const [password, setPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setErrorMessage('')
    setSuccessMessage('')

    if (newPassword !== confirm) {
      console.error('Les mots de passe ne correspondent pas')
      setErrorMessage('Les mots de passe ne correspondent pas')
      return
    }

    try {
      const data = await patchUpdatePassword(userId, password, newPassword)

      setSuccessMessage(data.message || 'Mot de passe mis à jour avec succès')

      setTimeout(() => {
        setPassword('')
        setNewPassword('')
        setConfirm('')
        setSuccessMessage('')
        navigate('/Profil')
      }, 2000)
    } catch (error) {
      console.error('Erreur mise à jour mot de passe:', error.message)
      setErrorMessage(error.message)
    }
  }

  return (
    <div className="reset-password">
      <h1 className="reset-password__title">Changer de mot de passe</h1>
      <hr className="reset-password__separator" />
      <form className="reset-password__form" onSubmit={handleSubmit}>
        <input
          type="text"
          value={user?.email || ''}
          autoComplete="username"
          readOnly
          style={{ display: 'none' }}
        />
        <input
          type="password"
          className="reset-password__input"
          value={password}
          autoComplete="current-password"
          placeholder="Ancien mot de passe *"
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          className="reset-password__input"
          value={newPassword}
          autoComplete="new-password"
          placeholder="Nouveau mot de passe *"
          onChange={(e) => setNewPassword(e.target.value)}
          required
        />
        <input
          type="password"
          className="reset-password__input"
          value={confirm}
          autoComplete="new-password"
          placeholder="Confirmer le mot de passe *"
          onChange={(e) => setConfirm(e.target.value)}
          required
        />
        <div className="reset-password-action">
          <Button
            variant="secondary"
            className="reset-password-action__return"
            onClick={() => navigate('/Profil')}
          >
            Retour
          </Button>
          <Button type="submit" variant="primary" className="reset-password-action__button">
            Modifier
          </Button>
        </div>

        <StatusMessage status="error" message={errorMessage} />
        <StatusMessage status="success" message={successMessage} />
      </form>
    </div>
  )
}

export default ResetPassword
